import { useState, useEffect } from 'react';
import { Skeleton, Stack } from '@mui/material';
import { ComponentsTypes } from '@/constants/componentsTypes';
import { CardContent } from './CardContent';
import { CardContentPadding } from '@/constants/cardContentTypes';
import { SectionContainer } from './SectionContainer';

export function SkeletonCard({ delay = 800 }) {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldRender(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  if (!shouldRender) {
    return null;
  }

  return (
    <SectionContainer>
      <CardContent
        component={{
          id: null,
          type: ComponentsTypes.CARD_CONTENT,
          padding: CardContentPadding.LARGE,
          components: [],
        }}
      >
        <Stack spacing={5}>
          <Skeleton
            variant='rounded'
            height={125}
          />
          <Stack spacing={2}>
            <Skeleton
              variant='rounded'
              height={58}
            />
            <Skeleton
              variant='rounded'
              height={58}
            />
          </Stack>
        </Stack>
      </CardContent>
    </SectionContainer>
  );
}
